import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';

import PointManagementView from './PointManagementView';

export default function PointManagementBox(props) {
  const {
    calcDateText,
    pointData,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isPointLoading,
  } = props;

  const { isDark } = useTheme();

  return (
    <TopLevelWrapper $isDark={isDark}>
      <PointManagementView
        calcDateText={calcDateText}
        pointData={pointData}
        selectedPartnerGym={selectedPartnerGym}
        isOpenPartnerGymSales={isOpenPartnerGymSales}
        isPointLoading={isPointLoading} />
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
  justify-content: center;

  margin: 39.5px 0;
  padding: 20px 40px;

  width: 100%;
  max-width: 960px;

  gap: 10px;

  border-radius: 20px;
  background-color: ${props => props.theme.subBackground};
`;
